import React from 'react'
import { Skeleton } from 'primereact/skeleton'
import './sckeletonBlog.scss'

const SckeletonBlog = () => {
  return (
    <div className="sckeletonBlog">
      <div className="article">
        <div className="article-imgBox">
          <Skeleton width="100%" height="150px" />
        </div>
        <div className="title__subtitle">
          <Skeleton width="10rem" className="mb-2" />
        </div>
        <div className="text__with-color">
          <Skeleton width="10rem" className="mb-2" />
        </div>
        <div className="text__container">
          <Skeleton height=".5rem" />
          <Skeleton height=".5rem" />
          <Skeleton height=".5rem" />
        </div>
        <div className="text__with-color">
          <Skeleton height=".5rem" width="4rem" />
        </div>
      </div>
    </div>
  )
}

export default SckeletonBlog
